import { PrimDropdownMenu } from "@/shared-web.ui/prim.dropdown-menu";

import { PrimProductTuneButton } from "../prim.product-tune-button";

interface ProductSortProps {
  setSortBy: (value: string) => void;
  sortBy: string;
  sortByChoices: {
    label: string;
    value: string;
  }[];
}
const ProductSort = (props: ProductSortProps) => {
  const {
    sortByChoices,
    setSortBy,
    sortBy,
  } = props;

  return (
    <PrimDropdownMenu.Root>
      <PrimDropdownMenu.Trigger asChild>
        <PrimProductTuneButton.SortTrigger>
          <PrimProductTuneButton.FilterTriggerText>
            {sortByChoices.find((o) => { return o.value === sortBy; })?.label}
          </PrimProductTuneButton.FilterTriggerText>
        </PrimProductTuneButton.SortTrigger>
      </PrimDropdownMenu.Trigger>
      <PrimDropdownMenu.Content align="end" className="w-44">
        <PrimDropdownMenu.Label inset>
          Sort By
        </PrimDropdownMenu.Label>
        <PrimDropdownMenu.RadioGroup
          onValueChange={(value) => {
            setSortBy(value);
          }}
          value={sortBy || ""}
        >
          {sortByChoices.map((choice) => {
            return (
              <PrimDropdownMenu.RadioItem
                checkedIndicator="check"
                key={choice.value}
                value={choice.value}
              >
                {choice.label}
              </PrimDropdownMenu.RadioItem>
            );
          })}
        </PrimDropdownMenu.RadioGroup>
      </PrimDropdownMenu.Content>
    </PrimDropdownMenu.Root>

  );
};

export {
  ProductSort,
};
